
import { useFilterExpenseGridStore } from "presentation/stores/use-filter-expense-grid-store";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import ExpenseForm from "../ExpenseForm";

interface ParamProps {
  onClose?: () => void;
  onOpen?: () => void;
  hideAddExpense?: boolean;
}

const HeaderExpenseGrid: React.FC<ParamProps> = (params: ParamProps) => {
  const { filters, setFilters, resetFilters } = useFilterExpenseGridStore();

  const [showModal, setShowModal] = useState(false);
  const toast = useRef<Toast>(null);

  const clearFilter = () => {
    resetFilters();
    setFilters({
      // query: { value: "", matchMode: "contains" },
      employeeName: { value: "", matchMode: "contains" },
      // date: { value: "", matchMode: "equals" },
      // createdAt: { value: "", matchMode: "equals" },
      type: { value: "", matchMode: "contains" },
      status: { value: "", matchMode: "contains" },
    });
  };

  const handleOpenModal = () => {
    setShowModal(true);
    params?.onOpen?.(); 
  };

  const handleCloseModal = () => {
    setShowModal(false);
    params?.onClose?.(); 
  };

  return (
    <div className="flex justify-content-between">
      <Dialog
        header="Submeter Despesa"
        visible={showModal}
        style={{ width: "50vw" }}
        onHide={handleCloseModal}
      >
        <ExpenseForm
          isDisable={false}
          onClose={handleCloseModal}
          toastRef={toast}
        />
      </Dialog>

      <div></div>

      <div style={{ display: "flex" }}>
        {!params.hideAddExpense && (
          <div style={{ display: "flex" }}>
            <Button
              type="button"
              icon="pi pi-plus"
              label="Submeter Despesa"
              outlined
              onClick={handleOpenModal}
              style={{
                backgroundColor: "#2196f3",
                color: "white",
                borderRadius: "8px",
              }}
            />
            <div style={{ width: "10px" }}></div>
          </div>
        )}

        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
      </div>

      <Toast ref={toast} position="bottom-right" />
    </div>
  );
};
export default HeaderExpenseGrid;
